import { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("wf_user");
    return raw ? JSON.parse(raw) : null;
  });
  const [subaccount, setSubaccount] = useState(() => {
    const raw = localStorage.getItem("wf_subaccount");
    return raw ? JSON.parse(raw) : null;
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Handle impersonation: ?_t=<token> in URL
    const params = new URLSearchParams(window.location.search);
    const impersonateToken = params.get("_t");
    if (impersonateToken) {
      localStorage.setItem("wf_token", impersonateToken);
      localStorage.removeItem("wf_user");
      localStorage.removeItem("wf_subaccount");
      // strip the param from URL
      params.delete("_t");
      const newSearch = params.toString();
      const newUrl = window.location.pathname + (newSearch ? `?${newSearch}` : "");
      window.history.replaceState({}, "", newUrl);
    }

    const token = localStorage.getItem("wf_token");
    if (token) {
      setLoading(true);
      api
        .get("/auth/me")
        .then((r) => {
          setUser(r.data.user);
          setSubaccount(r.data.subaccount);
          localStorage.setItem("wf_user", JSON.stringify(r.data.user));
          if (r.data.subaccount)
            localStorage.setItem("wf_subaccount", JSON.stringify(r.data.subaccount));
        })
        .catch(() => {
          localStorage.removeItem("wf_token");
          localStorage.removeItem("wf_user");
          localStorage.removeItem("wf_subaccount");
        })
        .finally(() => setLoading(false));
    }
  }, []); // eslint-disable-line

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("wf_token", r.data.token);
    localStorage.setItem("wf_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    // Load subaccount info
    const me = await api.get("/auth/me");
    setSubaccount(me.data.subaccount);
    if (me.data.subaccount)
      localStorage.setItem("wf_subaccount", JSON.stringify(me.data.subaccount));
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("wf_token");
    localStorage.removeItem("wf_user");
    localStorage.removeItem("wf_subaccount");
    setUser(null);
    setSubaccount(null);
  };

  return (
    <AuthCtx.Provider value={{ user, subaccount, loading, login, logout, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);

export const ROLE_LABELS = {
  super_admin: "Super Administrador",
  admin_candidato: "Admin Candidato",
  coord_estatal: "Coord. Estatal",
  coord_municipal: "Coord. Municipal",
  coord_regional: "Coord. Regional",
  coord_colonia: "Coord. de Colonia",
};

export const FULL_ROLES = ["admin_candidato", "coord_estatal", "coord_municipal"];
